const PAYMENTS_API_URL = import.meta.env.VITE_WS_PAYMENTS_API;

const fetchAPI = async (endpoint, errorMessage, method, body = null) => {
  const url = `${PAYMENTS_API_URL}/${endpoint}`;
  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  if (body) {
    options.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(url, options);
    const json = await response.json();

    if (response.ok) {
      return { data: json.data, meta: json.meta };
    } else {
      throw new Error(`${errorMessage}: ${json.status.message}`);
    }
  } catch (error) {
    console.error(errorMessage, error);
    throw new Error(error);
  }
};

export const sendInvoice = async (id, resendEmail) => {
  const response = await fetchAPI(`invoices/send/${id}`, 'Error sending invoice', 'PUT', { id, resendEmail });
  return response?.meta?.updateFields;
};
